import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/productsSearch/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/productsSearch/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/productsSearch/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadProductsByKeywords(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsByKeywords(params.keywords, query.page, query.pageSize, query.sort),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE]
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: [],
  pagination: {
    page: 1,
    totalPages: 1
  }
};

export default function productsSearchReducer (state = initialState, action) {
  switch(action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true
      }
		case LOAD_SUCCESS:
			return {
        ...state,
        loading: false,
        data: action.payload.items,
        pagination: action.payload.pagination,
        error: null
      }
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message
      }
      default:
  			return state;
  	}
  }
